
import {useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import ListaProgramas  from "./ListaProgramas";
import ListaUsuarios  from "./ListaUsuarios";


const DashboardSoporte = () => {

  const navigate = useNavigate();

  if(localStorage.getItem("rol")!=="soporte"){
    localStorage.clear();
    navigate("/")
  
  }


  return ( 
    <div className="container" style={{marginTop:"4rem"}}>
      <h2 className="p-3">Dashboard Soporte, Hola {localStorage.getItem("nombre")}!!</h2>
    <div className="row justify-content-center ">
      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-header">
            Usuarios
          </div>
          <div className="card-body">
           <ListaUsuarios></ListaUsuarios>
          </div>
        </div>
      </div>
      <div className="col-12 col-md-6">
        <div className="card">
          <div className="card-header">
           Programas
          </div>
          <div className="card-body">
          <ListaProgramas></ListaProgramas>
          </div>
        </div>
      </div>
    </div>
  </div>



  )
  
      
};
  


export default DashboardSoporte;
